import { trackMetric } from './telemetry/telemetry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// Send each web-vitals metric (e.g. page load time) to App Insights as a
// custom metric. reportWebVitals only measures anything when it's given a
// callback (see reportWebVitals.ts) — previously it was called with none,
// so no metric was ever measured at all.
reportWebVitals(metric => {
  trackMetric(metric.name, metric.value);
});
